__turbopack_context__.v({
  "container": "EditorialPushNotificationModal-module-scss-module__bJ0tiG__container",
});
